if (!customElements.get('fixed-atb')) {
  class FixedATB extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.handleObserve = this.handleObserve.bind(this);
      const options = {
        rootMargin: "-48px 0px 0px 0px",
      };

      this.observer = new IntersectionObserver(this.handleObserve, options);
      this.observer.observe(document.querySelector('product-info'));
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    handleObserve(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.classList.remove('active');
        } else {
          this.classList.add('active');
        }
      });
    }
  }
  
  customElements.define('fixed-atb', FixedATB);
}
